module.exports = __webpack_public_path__ + "static/img/small-logo.da227012.png";